import React, { useEffect, useRef, forwardRef } from "react";
import ChatHeader from "./ChatHeader";
import ChatMessages from "./ChatMessages";
import ChatInput from "./ChatInput";
import NoData from "../../../../elements/Nodata";
import image from "../../../../../assets/images/noChat.svg";
import { classNames } from "../../../../../helpers/classNames";
import { t } from "i18next";

const Inbox = forwardRef(
  (
    {
      messages,
      chatInfo,
      onSend = () => {},
      onMessageScroll = () => {},
      loading,
      setSelectedChat,
    },
    ref
  ) => {
    return (
      <div className="flex flex-col h-full">
        {chatInfo?._id && (
          <div className="relative">
            <ChatHeader info={chatInfo} setSelectedChat={setSelectedChat} />
            {loading && (
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 border border-primary bg-primary rounded-full px-3 py-1 text-white flex items-center gap-1 font-medium justify-center text-xs z-[1]">
                <i className="fa-regular fa-circle-notch animate-spin"></i>
                {t("Loading please wait")}
              </div>
            )}
          </div>
        )}
        <div
          ref={ref}
          className={classNames(
            chatInfo?._id
              ? "!h-[calc(100vh-320px)] overflow-y-auto flex bg-gray-50"
              : "h-full"
          )}
          style={{ transform: "rotateX(180deg)" }}
          onScroll={onMessageScroll}
        >
          {chatInfo?._id ? (
            <div
              className="pt-2 scrollbar-hidden mb-auto w-full p-6 bg-gray-50"
              style={{ transform: "rotateX(180deg)" }}
            >
              <ChatMessages messages={messages} />
            </div>
          ) : (
            <div
              className="bg-white rounded-lg h-full w-full flex items-center justify-center py-20"
              style={{ transform: "rotateX(180deg)" }}
            >
              <NoData
                image={image}
                message={t("You have'nt select any message yet")}
                imageClass={"w-96 h-96"}
              />
            </div>
          )}
        </div>
        {chatInfo?._id && <ChatInput onSend={onSend} />}
      </div>
    );
  }
);

export default Inbox;
